import React from "react";
import "../projects.css";
import proj1 from '../Images/oscilloscope.jpg'
import proj2 from '../Images/trainer.jpg'

const ProjectsPage = () => {
  const projects = [
    {
      title: "Augmented Reality Manual",
      description:
        "An interactive AR-based solution simplifying complex technical procedures of Oscilloscope with real-time assistance.",
      image: proj1,
    },
    {
      title: "Industrial AR Trainer",
      description:
        "Multiple training sessions on AR and VR Development provided at Ghulam Ishaq Khan Institute of Science & Technology (GIKI).",
      image: proj2
    },
  ];

  return (
    <div className="projects-page">
      <div className="banner">
        <h1>Our Projects</h1>
        <p>Explore the innovative solutions we've developed to revolutionize industries.</p>
      </div>
      <div className="projects-list">
        {projects.map((project, index) => (
          <div
            className={`project-row ${index % 2 === 0 ? "reverse" : ""}`}
            key={index}
          >
            <div className="project-image-wrapper">
              <img src={project.image}alt={project.title} className="project-image" />
            </div>
            <div className="project-content">
              <h2>{project.title}</h2>
              <p>{project.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectsPage;
